import teacherService from 'ApiService/Admin/teacherService';
import Card from 'components/card';
import { useState } from 'react';
import toast from 'react-hot-toast';
import Stepper from 'views/admin/main/users/newUser/components/Stepper';
import StepperControl from 'views/admin/main/users/newUser/components/Subject/StepperControl';
import { UseContextProvider } from 'views/admin/main/users/newUser/contexts/StepperContext';
import SelectTeacher from './Steps/SelectTeacher';
import SelectBatches from './Steps/SelectBatches';
import SelectDepartment from '../AssignTeacher/Steps/SelectDepartment'; // Re-using
import ConfirmationModal from 'pages/Common/ConfirmationModal';

const Index = () => {
  const [selectionIds, setSelectionIds] = useState([]);
  const [selectionTitle, setSelectionTitle] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [teacherData, setTeacherData] = useState({
    teacherId: '',
  });
  const [disable, setDisable] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const steps = [
    { stepNo: 1, name: 'Select Department' },
    { stepNo: 2, name: 'Select Teacher' },
    { stepNo: 3, name: 'Select Batches' },
  ];

  const handleAssignTeacher = async () => {
    if (selectionIds.length === 0) {
      return toast.error('Please select at least one batch.');
    }
    setIsModalOpen(true);
  };

  const confirmAssignment = async () => {
    if (loading) return;
    setLoading(true);
    const payload = {
      teacherId: teacherData.teacherId,
      selectionIds: selectionIds,
    };
    try {
      const response = await teacherService.assignTeacherToMultipleBatches(
        payload
      );
      if (response.data?.success) {
        toast.success(response?.data?.message);
        setSelectedBatch(null);
        setCurrentStep(1);
        setSelectionIds([]);
        setSelectionTitle([]);
        setSelectedDepartment('');
        setTeacherData({ teacherId: '' });
      } else {
        toast.error(response.data.message || 'Failed to assign batches.');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Something went wrong.');
    } finally {
      setLoading(false);
      setIsModalOpen(false);
    }
  };

  const displayStep = (step) => {
    switch (step.stepNo) {
      case 1:
        return (
          <SelectDepartment
            selectedDepartment={selectedDepartment}
            setSelectedDepartment={setSelectedDepartment}
            setDisable={setDisable}
          />
        );
      case 2:
        return (
          <SelectTeacher
            selectedDepartment={selectedDepartment}
            setTeacherData={setTeacherData}
            teacherData={teacherData}
            setDisable={setDisable}
          />
        );
      case 3:
        return (
          <SelectBatches
            selectedDepartment={selectedDepartment}
            teacherData={teacherData}
            selectedCourse={selectedCourse}
            selectedBatch={selectedBatch}
            selectedBranch={selectedBranch}
            setSelectedBranch={setSelectedBranch}
            setSelectedCourse={setSelectedCourse}
            setSelectedBatch={setSelectedBatch}
            selectionIds={selectionIds}
            setSelectionIds={setSelectionIds}
            selectionTitle={selectionTitle}
            setSelectionTitle={setSelectionTitle}
            setDisable={setDisable}
          />
        );
      default:
        return null;
    }
  };

  const handleClick = (direction) => {
    let newStep = currentStep;
    direction === 'next' ? newStep++ : newStep--;
    newStep > 0 && newStep <= steps.length && setCurrentStep(newStep);
  };

  return (
    <div className="md-mt-[3] mt-3 h-full w-full">
      <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px]" />
      <div className="w-md:2/3 mx-auto h-full w-5/6 md:px-3  3xl:w-7/12">
        <div className="-mt-[280px] w-full pb-10 md:-mt-[340px] md:px-[70px]">
          <Stepper steps={steps} currentStep={currentStep} />
        </div>
        <Card extra={'h-full mx-auto pb-3'}>
          <div className="rounded-[20px]">
            <UseContextProvider>
              {displayStep(steps[currentStep - 1])}
            </UseContextProvider>
          </div>
          <StepperControl
            handleClick={handleClick}
            currentStep={currentStep}
            steps={steps}
            disable={disable}
            loading={loading}
            handleSubmit={handleAssignTeacher}
          />
        </Card>
      </div>
      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={confirmAssignment}
        title="Confirm Teacher Assignment"
        message={`Are you sure you want to assign this teacher to selected batches?`}
        confirmText={loading ? 'Assigning...' : 'Assign Teacher'}
        cancelText="Cancel"
        icon="info"
        disableConfirm={loading}
      />
    </div>
  );
};

export default Index;
